import { IntlShape } from "react-intl";

export default function getSocialProviders(intl: IntlShape) {
  return [
    {
      value: "instagram",
      label: intl.formatMessage({
        id: "front_instagram",
        defaultMessage: "Instagram",
      }),
    },
    {
      value: "tik_tok",
      label: intl.formatMessage({
        id: "front_tiktok",
        defaultMessage: "Tiktok",
      }),
    },
    {
      value: "douyin",
      label: intl.formatMessage({
        id: "front_douyin",
        defaultMessage: "Douyin",
      }),
    },
    {
      value: "youtube",
      label: intl.formatMessage({
        id: "front_youtube",
        defaultMessage: "Youtube",
      }),
    },
    {
      value: "snapchat",
      label: intl.formatMessage({
        id: "front_snapchat",
        defaultMessage: "Snapchat",
      }),
    },
    {
      value: "facebook",
      label: intl.formatMessage({
        id: "front_facebook",
        defaultMessage: "Facebook",
      }),
    },
  ];
}
